import { createSlice } from '@reduxjs/toolkit';

const ensureCall = (state, callerId) => {
  if (!callerId) return;
  if (!state.calls[callerId]) {
    state.calls[callerId] = {
      visible: false,
      pinJobID: null,
      midasConferenceNumber: null,
      sessionStartedAt: null,
      callSessionKey: null,
      isCreatingSession: false,
      sessionError: null,
    };
  }
};

const textToVoiceSlice = createSlice({
  name: 'textToVoice',
  initialState: {
    calls: {},
  },
  reducers: {
    activateInput: (state, action) => {
      const callerId = action.payload;
      ensureCall(state, callerId);
      state.calls[callerId].visible = true;
    },
    deactivateInput: (state, action) => {
      const callerId = action.payload;
      ensureCall(state, callerId);
      state.calls[callerId].visible = false;
    },
    setSessionData: (state, action) => {
      const {
        callerId,
        pinJobID = null,
        midasConferenceNumber = null,
        callSessionKey,
      } = action.payload || {};
      ensureCall(state, callerId);
      if (!callerId) return;

      if (pinJobID) state.calls[callerId].pinJobID = pinJobID;
      if (midasConferenceNumber)
        state.calls[callerId].midasConferenceNumber = midasConferenceNumber;
      if (typeof callSessionKey !== 'undefined') {
        state.calls[callerId].callSessionKey = callSessionKey;
      }
      if (!state.calls[callerId].sessionStartedAt) {
        state.calls[callerId].sessionStartedAt = Date.now();
      }
    },
    clearSession: (state, action) => {
      const callerId = action.payload;
      if (!callerId) return;
      delete state.calls[callerId];
    },
    setSessionCreating: (state, action) => {
      const { callerId, isCreating } = action.payload;
      ensureCall(state, callerId);
      state.calls[callerId].isCreatingSession = isCreating;
      if (isCreating) {
        state.calls[callerId].sessionError = null;
      }
    },
    setSessionError: (state, action) => {
      const { callerId, error } = action.payload;
      ensureCall(state, callerId);
      state.calls[callerId].sessionError = error;
      state.calls[callerId].isCreatingSession = false;
    },
    clearSessionError: (state, action) => {
      const callerId = action.payload;
      ensureCall(state, callerId);
      state.calls[callerId].sessionError = null;
    },
  },
});

export const {
  activateInput,
  deactivateInput,
  setSessionData,
  clearSession,
  setSessionCreating,
  setSessionError,
  clearSessionError,
} = textToVoiceSlice.actions;

export const textToVoiceReducer = textToVoiceSlice.reducer;
export default textToVoiceReducer;
